import { render, staticRenderFns } from "./CompanyDetailsSales.vue?vue&type=template&id=573b6e46&scoped=true&"
import script from "./CompanyDetailsSales.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsSales.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetailsSales.vue?vue&type=style&index=0&id=573b6e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b6e46",
  null
  
)

export default component.exports